// extracted by mini-css-extract-plugin
export default {"vendorSelector":"VendorSelector_vendorSelector__zrrj2","selectAllBtn":"VendorSelector_selectAllBtn__2WJTE","confirmBtn":"VendorSelector_confirmBtn__3fcgw"};